<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <h1 class="m-0 text-dark">{{ $t('addInvestmentLender')}}</h1>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="col-12">
          <ValidationObserver ref="observer" v-slot="{ passes }">
            <form v-on:submit.prevent="passes(addLenderInvestment)">
              <div class="form-group">
                <label for="exampleInputNama">{{ $t('table.name')}}</label>
                <select class="form-control" v-model="addInvesment.priorityUser">
                  <option v-for="priorityUser in priorityUsers" :key="priorityUser._id"  :value="priorityUser._id" :selected="true">
                    {{priorityUser.name}}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputMataUang">{{ $t('table.currency')}}</label>
                <select @change="changeAmountOpt($event)" v-model="addInvesment.currency" class="custom-select">
                  <option v-for="option in currencyOptions" :key="option.value" :value="option.value">
                      {{ option.value }}
                    </option>
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputNominalPendanaan">{{ $t('table.nominalFund')}}</label>
                <select v-model=" addInvesment.amount" v-if="!isManual" class="custom-select">
                  <option v-for="option in amountOptions" v-bind:key="option.value" :value="option.value">
                    {{option.text}}
                  </option>
                </select>
                <ValidationProvider v-if="isManual && investmentForm.currency == 'IDR'" name="amount" rules="min_value:250000000" v-slot="{ errors }">
                  <input v-model="addInvesment.amount" class="form-control" type="text">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider v-if="isManual && investmentForm.currency == 'USD'" name="amount" rules="min_value:20000" v-slot="{ errors }">
                  <input v-model="addInvesment.amount" class="form-control" type="text">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <div>
                  <label>
                    <input type="checkbox" v-model="isManual">{{ $t('calcOther') }}
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label for="exampleInputJangkaWaktu">{{ $t('table.timePeriod')}}</label>
                <select type="text" class="form-control" id="exampleInputJangkaWaktu" autocomplete="off" v-model="addInvesment.timePeriod">
                  <option v-for="option in timePeriodOptions" v-bind:key="option.value" :value="option.value">
                     {{ option.text }} {{ $t('calYear')}}
                  </option>
                </select>
              </div>
              <!-- <div class="form-group">
                <label for="exampleStatus">Status</label>
                <select class="form-control" v-model=" addInvesment.status">
                  <option :selected="true" value="unpaid">Unpaid</option>
                </select>
              </div> -->
              <div class="form-group">
                <label for="exampleInputTanggalMulaiPenenpatanDana">{{ $t('table.dateOfPlacementFunds')}}</label>
                <input type="text" class="form-control" id="startDate" autocomplete="off" v-model=" addInvesment.investmentDate"/>
              </div>
             <button type="submit" class="btn btn-success ml-2 btn-rounded px-4" id="buttons">{{ $t('table.save')}}</button>
            </form>
          </ValidationObserver>
          <h5 class="text-center text-success">{{dataSuccess}}</h5>
          <h5 class="text-center text-danger">{{dataErr}}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ValidationObserver, ValidationProvider } from "vee-validate";

import { mapState, mapActions } from 'vuex'


export default {
  name: "addInvesmentLender",
  components:{
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      addInvesment:{
         priorityUser:"",
         currency:"",
         amount:"",
         timePeriod:"",
         investmentDate:"",
         status:"",
      },
      isManual: false,
      priorityUsers:[],
      dataSuccess:"",
      dataErr:""

    };
  },
  computed:{
    ...mapState([
      'currencyOptions',
      'timePeriodOptions',
      'amountOptions',
      'investmentForm'
    ])
  },
  mounted:function(){
    var self = this
    $("#startDate").datepicker({
      dateFormat: 'dd M yy',
      minDate: new Date(),
      onSelect:function(selectedDate, invesmentDate){
        let formatSelectedDate = self.$options.filters.formatDate(selectedDate);
        self.addInvesment.investmentDate = formatSelectedDate

      }
    })
  },
  created(){
    this.$axios
    .get("admin/v1/priority/lenders")
    .then(response =>{
      this.priorityUsers = response.data.data

    })
  },
  methods:{
    ...mapActions(['changeCurrency']),
    addLenderInvestment(){
      this.$axios
      .post("admin/v1/priority/investments/add-lender", this.addInvesment)
      .then(response =>{
        this.dataSuccess = "Data User Priority Lender Sukses disimpan"
      })
      .catch(error =>{
        this.dataErr = error
      })
    },
     changeAmountOpt(e) {
      let currency = e.target.value
      if(currency == "IDR") {
        this.isManual = false
      }
      this.changeCurrency(currency)
    }
  }
};
</script>

<style>
</style>
